import { z } from 'zod'

// 배너 이미지는 피처 플래그로 오버라이드하지 않는다.
// 배너는 어드민에서 관리하고, 이 화면은 lump-sum / ipad 결제 타입과 동일하게
// 앱에 포함된 정적 이미지를 쓴다. 플래그 payload 로 외부 이미지 URL 을 주입하던 방식은
// 허용 호스트를 스키마로 계속 관리해야 하고(next/image remotePatterns 와 이중 관리),
// 레거시 CDN 을 정리할 때 참조가 코드 밖에 숨어 추적되지 않는 문제가 있었다.
export const PaybackFlagSchema = z
  .object({
    enabled: z.boolean().optional(),
    hideAt: z.string().optional(),
    content: z
      .object({
        hero: z
          .object({
            title: z.string(),
            subtitle: z.string(),
            chips: z.array(z.string()),
          })
          .partial()
          .optional(),
        cardDescriptionsByMonth: z.record(z.string(), z.array(z.string())).optional(),
      })
      .partial()
      .optional(),
  })
  .partial()

export type PaybackFlag = z.infer<typeof PaybackFlagSchema>

/** 페이백 패키지 배너. lump-sum / ipad 와 동일하게 앱에 포함된 정적 이미지를 쓴다. */
export const PAYBACK_BANNER_IMAGE_URL = '/images/payback-package-banner.png'

export function parsePaybackFlag(value: unknown): PaybackFlag {
  let raw: unknown = {}

  if (typeof value === 'string') {
    try {
      raw = JSON.parse(value)
    } catch {
      raw = {}
    }
  } else if (value !== null && typeof value === 'object') {
    raw = value
  }

  const result = PaybackFlagSchema.safeParse(raw)
  return result.success ? result.data : {}
}

export function isPaybackAccessible(flag: PaybackFlag, now: Date = new Date()): boolean {
  if (flag.enabled !== true) {
    return false
  }
  if (!flag.hideAt) {
    return true
  }
  const hideAt = new Date(flag.hideAt)
  if (Number.isNaN(hideAt.getTime())) {
    return true
  }
  return now < hideAt
}
